import { useGroupCreateMutation } from "@/common/api/group/use-group-create.mutation";
import { toastMutationStatus } from "@/common/helpers/toast-mutation-status";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Form } from "@/components/ui/form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation } from "wouter";
import { GroupFormFields, formSchema, formSchemaType } from "./_components/group-form-fields";

export function GroupCreateView() {
  const { t } = useTranslation(["ram", "common"]);
  const pageTitle = t("ram:CreateGroup");
  const pageSubtitle = t("common:CompleteRequiredInformationDescription");
  const [_, navigate] = useLocation();
  const { isPending, mutateAsync } = useGroupCreateMutation();
  const form = useForm<formSchemaType>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
    },
  });

  const onSubmit = async (values: formSchemaType) => {
    await toastMutationStatus({
      mutationFn: () =>
        mutateAsync({
          name: values.name,
          appRoles: [],
        }),
      successMessage: t("ram:GroupHasBeenAdded"),
      errorMessage: t("ram:ErrorCreatingGroup"),
    });

    navigate("/");
  };

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
          <GroupFormFields isLoading={isPending} formControl={form.control} />
        </form>
      </Form>
    </CenteredLayout>
  );
}
